import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { NumericFormat } from "react-number-format";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AccountManagerService from "../../services/Celcoin/accountManagerService";
import StaticCashInService from "../../services/Celcoin/staticChargeCashInService";
import KeysManagementService from "../../services/Celcoin/keysManagementService";
import { getTranslations } from "../../services/languageUtils";
import { isMutual } from "../../utils/isMutual";
import { isMtBank } from "../../utils/isMtBank";

const DEPOSIT_QR_BLOCKED_EMAILS = [
  "higher.otc.adm@higherglobal.com.br",
  "higher.bxin.adm@higherglobal.com.br",
  "higher.otc.api.adm@higherglobal.com.br",
];
const DEPOSIT_QR_BLOCKED_ACCOUNTS = [
  "71278676016710101005",
  "36580026347710101003",
  "20712166477710101000",
];
const DEPOSIT_QR_BLOCKED_PIX_KEYS = [
  "16af3f00-f9fd-4d12-88db-8b61099ed854",
  "e4f37a4c-2751-4b10-b05e-529c804f2e8d",
  "c81370ec-dba1-42a4-ae82-34d3d4657b16",
];

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankNumber: "509",
      branch: "",
      account: "",
      pixKey: "",
      hasPixKey: false,
      qrCode: "",
      qrCodeImageBase64: "",
      listKeys: [],
      amount: 100,
      translations: {},
      load: false,
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.setState({ load: true });
    this.updateData();
    this.loadTranslations();
  }

  isDepositQrBlocked = (pixKey = this.state.pixKey) => {
    const email = (sessionStorage.getItem("emailUser") || "").toLowerCase();
    const account =
      sessionStorage.getItem("account") || this.state.account || "";
    const normalizedPixKey = (pixKey || "").toLowerCase();

    return (
      DEPOSIT_QR_BLOCKED_EMAILS.includes(email) ||
      DEPOSIT_QR_BLOCKED_ACCOUNTS.includes(account) ||
      DEPOSIT_QR_BLOCKED_PIX_KEYS.includes(normalizedPixKey)
    );
  };

  getKey() {
    if (
      sessionStorage.getItem("emailUser") === "financeiro@highersolucoes.com" ||
      sessionStorage.getItem("emailUser") === "faleconosco@vemdepremios.com.br"
    )
      return "205a38b6-cc6f-4cf2-8c9e-86ebfbb3165a";
    else if (sessionStorage.getItem("emailUser") === "vivian.chaves@pmi.tech")
      return "ae39e5ad-89ae-4b73-9879-e83224814353";
    else if (
      sessionStorage.getItem("emailUser") ===
        "financeiro@higherglobal.com.br" ||
      sessionStorage.getItem("emailUser") === "ana.vale@higherglobal.com.br" ||
      sessionStorage.getItem("emailUser") === "davi@cryptouse.com.br" ||
      sessionStorage.getItem("emailUser") === "bruno.riscado@highersolucoes.com"
    )
      return "2b6faff7-3d1c-4fae-956a-86bf8a823aa4";
    else if (sessionStorage.getItem("emailUser") === "contato@zicredit.com.br")
      return "0b46b487-d0f8-4e88-9e01-7b3b3155cbaf";
    else if (
      sessionStorage.getItem("emailUser") === "ernesto.galvan@pmi.tech" ||
      sessionStorage.getItem("emailUser") === "thathiana.enriquez@pmi.tech" ||
      sessionStorage.getItem("emailUser") === "felix.corrales@pmi.tech"
    )
      return "395d590b-2304-4b1a-9f91-83b9b1c874ca";
    else if (
      sessionStorage.getItem("emailUser") === "marcio@tcr.finance" ||
      sessionStorage.getItem("emailUser") === "ricardo@tcr.finance"
    )
      return "91669a6d-861c-494a-86b2-4f812fb67bc1";
    else if (sessionStorage.getItem("emailUser") === "otc@comprarbitcoin.trade")
      return "fa2a0eb4-42b6-451e-88d4-f33354ec84a3";
    else if (
      sessionStorage.getItem("emailUser") === "nathan.diogo@cipay.com.br"
    )
      return "9758c1f4-62ac-43fd-bc82-65394c704ebc";
    else if (
      sessionStorage.getItem("emailUser") ===
      "viniciusdigitalempresas@gmail.com"
    )
      return "9cab6058-fc7d-46f7-8fd1-473a536df62e";
    else if (
      sessionStorage.getItem("emailUser") === "omena.davyson@primepag.com.br"
    )
      return "bd5f8da1-271a-44a9-9246-23bf1b72911f";
    else if (
      sessionStorage.getItem("emailUser") === "victor.nery@firebanking.io"
    )
      return "56faa613-cdba-4315-8478-208d8c417ff5";
    else if (
      sessionStorage.getItem("emailUser") === "default@eroninternational.com" ||
      sessionStorage.getItem("emailUser") ===
        "administrativo@renovapaypagamentos.com"
    )
      return "627bf85e-8257-4354-83d5-be821af4648a";
    else if (
      sessionStorage.getItem("emailUser") ===
        "financeiro1@highersolucoes.com" ||
      sessionStorage.getItem("emailUser") === "agustin@pay-pros.com" ||
      sessionStorage.getItem("emailUser") === "asanchez@pay-pros.com"
    )
      return "c01fc205-1b0e-46a2-9d63-2993b6ac1c34";
  }

  async updateData() {
    const that = this;

    if (isMutual() || isMtBank()) {
      try {
        const keyResponse = await KeysManagementService.index();
        const listKeys = Array.isArray(keyResponse?.data)
          ? keyResponse.data
          : keyResponse?.data?.body?.listKeys || [];
        const activePixKey = listKeys[0]?.key || "";

        this.setState({
          listKeys,
          pixKey: activePixKey,
          hasPixKey: !!activePixKey,
          account: sessionStorage.getItem("account") || "",
          branch: sessionStorage.getItem("agency") || "",
        });

        if (this.isDepositQrBlocked(activePixKey)) {
          this.setState({ qrCode: "", qrCodeImageBase64: "", load: false });
          return;
        }

        if (!activePixKey) {
          this.setState({ qrCode: "", qrCodeImageBase64: "", load: false });
          return;
        }

        const qrResponse = await StaticCashInService.create({
          key: activePixKey,
          amount: this.state.amount,
          additionalInformation: " ",
        });

        that.setState({
          qrCode: qrResponse?.data?.emvqrcps || "",
          qrCodeImageBase64: qrResponse?.data?.qrcodeImageBase64 || "",
          load: false,
        });
      } catch (err) {
        console.error(err);
        that.setState({ load: false });
      }
    } else {
      if (sessionStorage.getItem("doc").length < 13) {
        AccountManagerService.showAccountPF()
          .then((resAccount) => {
            that.setState({
              branch: resAccount.data.body.account.branch,
              account: resAccount.data.body.account.account,
            });

            KeysManagementService.index()
              .then((res) => {
                that.setState({
                  pixKey: res.data.body.listKeys[0].key,
                  listKeys: res.data.body.listKeys,
                });
                StaticCashInService.create({
                  merchant: {
                    merchantCategoryCode: "5651",
                    city: resAccount.data.body.address.city,
                    name: res.data.body.listKeys[0].owner.name,
                    postalCode: resAccount.data.body.address.postalCode,
                  },
                  key: res.data.body.listKeys[0].key
                    ? res.data.body.listKeys[0].key
                    : sessionStorage.getItem("emailUser"),
                  amount: this.state.amount,
                  transactionIdentification: `${Date.now()}${Math.random().toString(36).substr(2, 5)}`,
                  tags: [],
                  email: sessionStorage.getItem("emailUser"),
                  additionalInformation: " ",
                })
                  .then((res) => {
                    that.setState({
                      qrCode: res.data.emvqrcps,
                      qrCodeImageBase64: res?.data?.qrcodeImageBase64 || "",
                      load: false,
                    });
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        AccountManagerService.showAccountPJ()
          .then((resAccount) => {
            that.setState({
              branch: resAccount.data.body.businessAccount.branch,
              account: resAccount.data.body.businessAccount.account,
            });

            KeysManagementService.index()
              .then((res) => {
                that.setState({
                  pixKey: res.data.body.listKeys[0].key,
                  listKeys: res.data.body.listKeys,
                });
                StaticCashInService.create({
                  merchant: {
                    merchantCategoryCode: "5651",
                    city: resAccount.data.body.businessAddress.city,
                    name: res.data.body.listKeys[0].owner.name,
                    postalCode: resAccount.data.body.businessAddress.postalCode,
                  },
                  key: res.data.body.listKeys[0].key
                    ? res.data.body.listKeys[0].key
                    : sessionStorage.getItem("emailUser"),
                  amount: this.state.amount,
                  transactionIdentification: `${Date.now()}${Math.random().toString(36).substr(2, 5)}`,
                  tags: [],
                  email: sessionStorage.getItem("emailUser"),
                  additionalInformation: " ",
                })
                  .then((res) => {
                    that.setState({
                      qrCode: res.data.emvqrcps,
                      qrCodeImageBase64: res?.data?.qrcodeImageBase64 || "",
                      load: false,
                    });
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  updateValueTransfer(value) {
    const that = this;
    this.setState({ amount: Number(value), load: true }, () => {
      that.updateData();
    });
  }

  handleChange = (event) => {
    this.setState({ pixKey: event.target.value });
  };

  copyToClipboard = () => {
    if (!this.state.load) {
      navigator.clipboard
        .writeText(this.state.qrCode)
        .then(() => {
          return toast(this.state.translations.qrCodeCopiedSuccessfully, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "success",
            theme: "light",
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  render() {
    const hideDepositQrCard = this.isDepositQrBlocked();

    return (
      <section
        className="AccountInfoComponent"
        id="AccountInfoComponent"
        style={{ width: "95%" }}
      >
        {!isMutual() && !isMtBank() && (
          <span>
            <b>{this.state.translations.account_information}</b>
            <br />
          </span>
        )}
        {isMutual() && !isMtBank() && <span></span>}

        <div style={{ display: "block" }}>
          <div>
            {!isMutual() && !isMtBank() && (
              <div style={{ display: "flex" }}>
                <div className="contentItem">
                  {this.state.translations.bank_number}
                  <br />
                  <b>{this.state.bankNumber}</b>
                </div>
                <div className="contentItem">
                  {this.state.translations.branch}
                  <br />
                  <b>{this.state.branch}</b>
                </div>
                <div className="contentItem">
                  {this.state.translations.account}
                  <br />
                  <b>{this.state.account}</b>
                </div>
              </div>
            )}

            <div style={{ display: "flex" }}>
              {!hideDepositQrCard && (
                <div className="contentItem">
                  {this.state.translations.how_much_will_you_receive + "?"}
                  <NumericFormat
                    className="input"
                    value={this.state.amount}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    prefix="R$ "
                    onValueChange={(values) => {
                      const { value } = values;
                      this.updateValueTransfer(value);
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            {!hideDepositQrCard && (
              <>
                <div className="contentItem">
                  {!this.state.load && isMtBank() && (
                    <QRCodeCanvas
                      className="QRCodeCanvas"
                      id="qrCode"
                      value={this.state.qrCode}
                      size={100}
                      bgColor={"#ffffff"}
                      level={"H"}
                    />
                  )}

                  {!this.state.load &&
                    !isMtBank() &&
                    this.state.hasPixKey &&
                    this.state.qrCodeImageBase64 && (
                      <img
                        src={`data:image/png;base64,${this.state.qrCodeImageBase64}`}
                        alt="QrCode"
                        width={"180px"}
                      />
                    )}

                  {!this.state.load &&
                    !isMtBank() &&
                    this.state.hasPixKey &&
                    !this.state.qrCodeImageBase64 && (
                      <QRCodeCanvas
                        className="QRCodeCanvas"
                        id="qrCode"
                        value={this.state.qrCode}
                        size={100}
                        bgColor={"#ffffff"}
                        level={"H"}
                      />
                    )}

                  {!this.state.load && !this.state.hasPixKey && (
                    <div
                      style={{
                        maxWidth: "220px",
                        fontSize: "14px",
                        color: "#696C70",
                        margin: "0 auto",
                      }}
                    >
                      Nenhuma chave Pix ativa disponível para gerar QR Code.
                    </div>
                  )}

                  {this.state.load && (
                    <div class="loader">
                      <div class="spinner"></div>
                    </div>
                  )}
                </div>

                <div style={{ display: "flex" }}>
                  {!this.state.load && this.state.hasPixKey && (
                    <button
                      onClick={() => {
                        this.copyToClipboard();
                      }}
                      className="w-full px-4 py-2 backgroundPrimary text-white rounded"
                    >
                      {this.state.translations.copy}
                    </button>
                  )}
                  {!this.state.load && !this.state.hasPixKey && (
                    <button
                      onClick={() => {
                        window.location.href = "/transfers/pix";
                      }}
                      className="w-full px-4 py-2 backgroundPrimary text-white rounded"
                    >
                      Criar chave Pix
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <ToastContainer />
      </section>
    );
  }
}

export default Item;
